<div class="control" [class.bg-black-4]="!isBaseSelected"  (click)="toggleModal()">
  <div class = "card-control-text">
    <span class="font-4 bold500">
      {{label}}
    </span>
    <ng-container *ngIf="isBaseSelected">
      <span class="font-2">
        All
      </span>
    </ng-container>
    <ng-container *ngIf="!isBaseSelected">
      <ng-container *ngIf="type === '%'">
        <span class="font-2 span-over">
          {{ infoForModal.minValue | number: '1.0' | negativeValueToBraces }}% - {{ infoForModal.maxValue | number: '1.0' }}%
        </span>
      </ng-container>
      <ng-container *ngIf="type !== '%'">
        <span class="font-2 span-over">
          {{ infoForModal.minValue | number: '1.0' | negativeValueToBraces }} - {{ infoForModal.maxValue | number: '1.0' | negativeValueToBraces }}
        </span>
      </ng-container>
    </ng-container>
  </div>
  <div class="centered-row-container row-gap-0p5em">
    <app-all-icons *ngIf="!isBaseSelected" class="icon-size-1" [iconNameAndStyling]="'close.svg'" (click)="closeImgClick(); $event.stopPropagation()"></app-all-icons>
    <app-dropdown-icon class="suffix"></app-dropdown-icon>
  </div>

  <app-popup-modal *ngIf="showModal">
    <div [formGroup]="modalParamForm" class="card-dropdown-body vertical-container-simple column-gap-1 width-96pcnt" (click)="$event.stopPropagation();" >
      <app-input
        data-qa="modal-ticker-min"
        formControlName="minValue"
        [thousandSeparator]="','"
        [separator]="'separator'"
        [title]="type === '%' ? 'From, %' : 'From'"
        [allowNegativeNumbers]="true">
      </app-input>
      <app-input
        data-qa="modal-ticker-max"
        formControlName="maxValue"
        [thousandSeparator]="','"
        [separator]="'separator'"
        [title]="type === '%' ? 'Till, %' : 'Till'"
        [allowNegativeNumbers]="true">
      </app-input>
      <div class = "centered-row-container row-gap-0p5">
        <app-button
          data-qa="button-modal-ticker-reset"
          [size]="'small'"
          [type]="'default'"
          (click)="applyChanges(true); $event.stopPropagation()">
          Reset
        </app-button>
        <app-button
          data-qa="button-modal-ticker-apply"
          [size]="'small'"
          [type]="'accent'"
          (click)="applyChanges(false); $event.stopPropagation()">
          Apply
        </app-button>
      </div>
    </div>
  </app-popup-modal>
</div>
